/**
 * @generated SignedSource<<c7c15d249e11413cb395933897ced413>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerPreviewString_answer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "AnswerString",
  "abstractKey": null
};

node.hash = "2923908659a6c4cbf371fb6e1965c6a0";

module.exports = node;
